import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { platformService } from '@/api/services/platform';
import { spaceService } from '@/api/services/serverless/space';
import { head } from '@/router/Head';
import { clusterListSearchSchema } from '@/router/utils';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/')({
  // The empty list offers the clusters' first-run choice, whose free form keeps its provider and region in the URL.
  validateSearch: clusterListSearchSchema,
  staticData: {
    title: 'Serverless Spaces',
  },
  beforeLoad: ({ context: { queryClient }, params: { accountId } }) => {
    // The first deployment choice of an empty list reads the providers. Public, so no permission to check.
    const listCloudProvidersQuery = platformService.listCloudProvidersQuery({ accountId });
    void queryClient.prefetchQuery(listCloudProvidersQuery);

    return { listSpacesQuery: spaceService.listSpacesQuery({ accountId }), listCloudProvidersQuery };
  },
  // Fetching the list runs the permissions interceptor, which throws an AccessControlError
  // (handled as a not-found) when the user lacks `read:serverless_spaces`.
  loader: ({ context: { queryClient, listSpacesQuery } }) => queryClient.ensureQueryData(listSpacesQuery),
  head,
  component: lazyRouteComponent(
    () => import('@/components/Serverless/ServerlessSpacesPage'),
    'ServerlessSpacesIndexComponent',
  ),
  pendingComponent: lazyRouteComponent(
    () => import('@/components/Serverless/ServerlessSpacesPage'),
    'ServerlessSpacesPendingComponent',
  ),
});
